import { render } from "./OnboardingView.vue?vue&type=template&id=2180ee73&scoped=true"
import script from "./OnboardingView.vue?vue&type=script&lang=js"
export * from "./OnboardingView.vue?vue&type=script&lang=js"

import "./OnboardingView.vue?vue&type=style&index=0&id=2180ee73&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2180ee73"]])

export default __exports__